<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout" [class.loading]="isLoading">
        <div class="content">
            <div class="ui segment">
                <app-deprecated-task-form #taskForm [employee]="employee" [task]="task"></app-deprecated-task-form>
            </div>
            <div class="action-buttons">
                <ui-button url=".."> Cancel </ui-button>
                <ui-button (click)="save(taskForm)" type="primary"> Save </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">Employee Tasks</h3>
                <p>
                    This task will only apply to the selected employee and will not appear in the offboarding tasks
                    page.
                </p>
                <p>
                    <a
                        (click)="
                            analytics.logLinkOpen(
                                'https://humi.zendesk.com/hc/en-us/articles/360048623254',
                                events.OffboardingTaskLearnMore
                            )
                        "
                        >Learn more</a
                    >
                    about tasks.
                </p>
            </div>
        </div>
    </div>
</div>
